import { api } from '../../utils/api'

export enum Errors {
	NOT_AUTHORIZED = `NOT_AUTHORIZED`
}

export const GetLogged = async () => await api.get(`/logged`)